import { createContext } from "react";

export const useUser = createContext<any>("");
